import React from 'react';
import Reflux from 'reflux';
import {Button, message, Row, Col} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, DisplayForm} from '../../components';
import {formatMoney, openNotice, config} from 'Utils';
import {detail} from '../../service/thingsOrder';
import {
    getOrderDetails
} from '../../service/order';
import moment from 'moment';
import './table.css';

class DeliveryConfirmPrint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // opts: ['查看销售单'],
            // type: ~~this.props.params.type,
            key: 0,
            selectedRowKeys: [],
            rows: [],

            detailData: {},
            editStatus: 'block',
            orderDetail: {},
            total: 1,
            searchObj: {
                s: 10,
                p: 1
            },
            value: '',
            amountAll4: 0
            // distributor:JSON.parse(window.sessionStorage.getItem('distributor'))
        };
        this.pageChange = this.pageChange.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.goBack = this.goBack.bind(this);
        this.goView = this.goView.bind(this);
        this.initData = this.initData.bind(this);
    };

    goBack() {
        hashHistory.goBack();
    }

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    print = () => {

    };

    /*获取列表数据*/
    initData(key) {
        let id = this.props.params.id;
        var realQuantityAll = 0;
        // var amountAll = 0;
        // var amountAll2 = 0;
        var amountAll3 = 0;
        //var amountAll4 = 0; //扣点金额合计
        var countAll = 0;
        var returnaddress = "";
        var returnlinkman = "";
        var returnphone = "";
        const data = JSON.parse(window.sessionStorage.getItem('deliveryconfirmprint'));
        if (data.gobackType == null) {
            returnaddress = data.printAddress;
            returnlinkman = data.printLinkman;
            returnphone = data.printPhone;
        } else {
            returnaddress = "浙江省嘉兴市秀洲区中山西路2777号浙江天正智能电器有限公司";
            returnlinkman = "年介拽";
            returnphone = "15868072358";
        }
        //console.log(data);
        for (let i = 0; i < data.productList.length; i++) {
            data.productList[i].id = i + 1;
            // realQuantityAll += data.lineList[i].gobackCount;
            countAll += data.productList[i].count;
            //amountAll += data.productList[i].discountPrice;
            //amountAll2 += data.productList[i].discountMoney;
            // amountAll3 =  amountAll3 + (data.productList[i].discountPrice * data.productList[i].count);
            if (data.productList[i].checkPrice === null || data.productList[i].checkPrice === '') {
                if (data.productList[i].terminalUnitPrice === null || data.productList[i].terminalUnitPrice === '') {
                    data.productList[i].discountMoney = data.productList[i].price * data.productList[i].count;
                } else {
                    data.productList[i].discountMoney = data.productList[i].terminalUnitPrice * data.productList[i].count;
                }
            } else {
                data.productList[i].discountMoney = data.productList[i].checkPrice * data.productList[i].count;
            }
            amountAll3 += (data.productList[i].discountMoney);
            // amountAll3 =  amountAll3 + (data.productList[i].checkPrice * data.productList[i].count);

            // data.productList[i].discountPrice = data.productList[i].discountPrice.toFixed(2);
            //amountAll4 = amountAll4 + (data.productList[i].sellPrice * data.productList[i].realQuantity * data.productList[i].refunds /100);
        }
        var x = amountAll3;
        // var y = amountAll4.toFixed(2);
        var data1 = [...data.productList];
        data1.push({id: '', originalPrice: '合计:', count: countAll, checkPriceRate: ' ', discountMoney: x});
        this.setState({
            rows: data1,
            detailData: data,
            returnaddress: returnaddress,
            returnlinkman: returnlinkman,
            returnphone: returnphone
        });
    }


    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {

    }


    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        //  this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    render() {
        const {/*distributor, */rows, total, searchObj, resultData, type, detailData, orderDetail, data} = this.state;
        // console.log(detailData);
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: false,
            // pageParam: {
            //   total: total,
            //   current: searchObj.p,//当前页码
            //   pageSize: searchObj.s,//当前分页数
            //   onChange: this.pageChange
            // },
            columns: [

                {
                    title: '序号',
                    dataIndex: 'id'
                },
                {
                    title: '货号',
                    dataIndex: 'productCode'
                },
                {
                    title: '型号',
                    dataIndex: 'productName'
                },
                {
                    title: '单价',
                    dataIndex: 'checkPrice',
                    render: (text, record, index) => {
                        //console.log(record);
                        if (record.checkPrice === null || record.checkPrice === '') {
                            if (record.terminalUnitPrice === null || record.terminalUnitPrice === '') {
                                return <div>{record.price}</div>
                            } else {
                                return <div>{record.terminalUnitPrice}</div>
                            }
                        } else {
                            return <div>{text}</div>
                        }
                    }
                },
                {
                    title: '牌价',
                    dataIndex: 'originalPrice'
                },
                {
                    title: '数量',
                    dataIndex: 'count'
                },
                {
                    title: '下浮率（%）',
                    dataIndex: 'checkPriceRate',
                    render: (text, record, index) => {
                        if (record.checkPriceRate == null || record.checkPriceRate == '') {
                            if (record.terminalPriceRate == null || record.terminalPriceRate == '') {
                                return <div>{(record.price / record.originalPrice * 100).toFixed(2)}</div>
                            } else {
                                return <div>{record.terminalPriceRate || 0}</div>
                            }
                        } else {
                            return <div>{record.checkPriceRate || 0}</div>
                        }
                    }
                },
                {
                    title: '合计',
                    dataIndex: 'discountMoney',
                    render:
                        (text, record, index) => {
                            return <div>{text.toFixed(2) || 0}</div>
                        }
                },
                {
                    title: '生产周期（天）',
                    dataIndex:
                        'productionCycle'
                }
            ],
            paginationHide: true,
            rows
        };

        const
            h1 = {width: '100%', textAlign: 'center'}
        const
            shiwu = {textAlign: 'center'}
        const
            h2 = {width: '100%', paddingLeft: 300}
        const
            top = {width: '100%', textAlign: 'center', position: 'relative'}
        const
            printDate = moment(new Date()).format('YYYY/MM/DD');
        const
            left = {paddingLeft: 800, position: 'absolute', left: 200,}
        //const left1 ={paddingLeft:200,position:'fixed',left:200,}
        console
            .log(detailData);

        var
            myDate = new Date();

        return (

            <div style={{padding: '20px', lineHeight: '30px'}}>
                <table style={{width: '100%', color: '#000000'}}>
                    <tr>
                        <td colSpan={4} style={{textAlign: 'center'}}><h1 style={h1}>收货确认单</h1></td>
                    </tr>
                    <tr>
                        <td style={{textAlign: 'right', width: '25%'}}><h2>客户信息</h2></td>
                        <td width="25%" colSpan={3}></td>
                    </tr>
                    <tr>
                        <td style={{textAlign: 'right', width: '25%'}}>要货单号：</td>
                        <td style={{textAlign: 'left', width: '25%'}}>{detailData.getProCode}</td>
                        <td style={{textAlign: 'right', width: '25%'}}>订单日期：</td>
                        <td style={{
                            textAlign: 'left',
                            width: '25%'
                        }}>{moment(detailData.createdDate).format('YYYY-MM-DD HH:mm:ss')}</td>
                    </tr>
                    <tr>
                        <td style={{textAlign: 'right', width: '25%'}}>客户名称：</td>
                        <td style={{textAlign: 'left', width: '25%'}}>{detailData.customerName}</td>
                        <td style={{textAlign: 'right', width: '25%'}}>终端单位：</td>
                        <td style={{textAlign: 'left', width: '25%'}}>{detailData.projectMessage}</td>
                    </tr>
                    <tr>
                        <td style={{textAlign: 'right', width: '25%'}}>订货仓库：</td>
                        <td style={{textAlign: 'left', width: '25%'}}>{detailData.delvName}</td>
                        <td style={{textAlign: 'right', width: '25%'}}>收货省市：</td>
                        <td style={{textAlign: 'left', width: '25%'}}>{detailData.gatherCity}</td>
                    </tr>
                    <tr>
                        <td style={{textAlign: 'right', width: '25%'}}>天正ERP订单号：</td>
                        <td style={{textAlign: 'left', width: '25%'}}>{detailData.code}</td>
                        <td style={{textAlign: 'right', width: '25%'}}>客户订单号：</td>
                        <td style={{textAlign: 'left', width: '25%'}}>{detailData.customerOrderCode}</td>
                    </tr>
                    <tr>
                        <td style={{textAlign: 'right', width: '25%'}}>实际收货地址：</td>
                        <td colSpan={3} style={{textAlign: 'left', width: '25%'}}>{detailData.gatherRealityAddress}</td>
                    </tr>
                    <tr>
                        <td style={{textAlign: 'right', width: '25%'}}>打印时间：</td>
                        <td colSpan={3} style={{textAlign: 'left', width: '25%'}}>{myDate.toLocaleDateString()}</td>
                    </tr>
                    <tr>
                        <td colSpan={4} style={{textAlign: 'left', width: '25%'}}><h2>订货内容</h2></td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                            <div className='yourClass'><TableView {...tableViewProps} /></div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4} style={{textAlign: 'left', width: '25%'}}>注：以上为含税价格</td>
                    </tr>
                    <tr>
                        <td colSpan={4} height="60px"></td>
                    </tr>
                    <tr>
                        <td style={{textAlign: 'right', width: '25%'}}><h2>签字确认：</h2></td>
                        <td width="25%" colSpan={3}></td>
                    </tr>
                    <tr>
                        <td colSpan={4} height="60px"></td>
                    </tr>
                    <tr>
                        <td style={{textAlign: 'right', width: '25%'}}>供方：</td>
                        <td style={{textAlign: 'left', width: '25%'}}>浙江天正电气股份有限公司</td>
                        <td style={{textAlign: 'right', width: '25%'}}>代理商：</td>
                        <td style={{textAlign: 'left', width: '25%'}}></td>
                    </tr>
                    <tr></tr>
                </table>
            </div>
        )
    }
}

export default DeliveryConfirmPrint;



// WEBPACK FOOTER //
// ./src/routes/print/deliveryConfirmPrint.js